<script setup>
import { ref, computed } from "vue";
import Width from "@/pages/Index/Width.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import { useStore } from "vuex";

const store = useStore()

const currentLang = computed(() => store.getters.currentLanguage)

const info = computed(() => {
	return [
		{
			label: 'manufacture.team.technicalPersonnel',
			icon: 'teamwork',
			value: '40+'
		},
		{
			label: 'manufacture.team.undergraduateDegree',
			icon: 'diploma',
			value: '50%'
		},
		{
			label: 'manufacture.team.developmentCenter',
			icon: 'target',
			value: `3${currentLang.value === 'cn' ? '个' : ''}`
		},
		// {
		// 	label: 'manufacture.team.GenuineDesignSoftware',
		// 	icon: 'cms',
		// 	value: 'NX、CAXA'
		// }
	]
})
</script>

<template>
	<div class="dev-team">
		<Width>
			<div class="dev-team__content">
				<div class="dev-team__content__title">
					{{ $t('manufacture.team.title') }}
				</div>
				
				<div class="dev-team__content__detail">
					{{ $t('manufacture.team.content') }}
				</div>
				
				<div class="dev-team__content__data info">
					<div
						v-for="(item, index) in info"
						:key="index"
						class="info__list"
					>
						<div class="info__card">
							<SvgIcon
								:name="item.icon"
								class-name="info__card__icon"
							/>
							
							<div class="info__card__value">
								{{ item.value }}
							</div>
							
							<div class="info__card__label">
								{{ $t(item.label) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Width>
	</div>
</template>

<style scoped lang="less">
.dev-team {
	background-image: url("~@/assets/images/bg/team.png");
	background-position: center 40%;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 72px 0;
	
	&__content {
		width: 65%;
		
		&__title {
			font-size: 48px;
			font-weight: bold;
			background: linear-gradient(279deg, #D1170E 3%, #F46760 100%), linear-gradient(279deg, #DA241B -3%, #F0554D 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			text-fill-color: transparent;
			margin-bottom: 36px;
		}
		
		&__detail {
			font-size: 18px;
			line-height: 32px;
			color: #606266;
		}
		
		.info {
			margin-top: 64px;
			display: flex;
			justify-content: space-between;
			
			&__card {
				text-align: center;
				&__icon {
					width: 72px;
					height: 72px;
				}
				
				&__value {
					text-align: center;
					font-size: 32px;
					font-weight: bold;
					color: #303133;
					margin: 12px 0 4px 0;
				}
				
				&__label {
					text-align: center;
					font-size: 18px;
					color: #606266;
				}
				
			}
			
		}
		
	}
}

@media only screen and (max-width: 1200px) {
	.dev-team {
		
		&__content {
			width: 100%;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.dev-team {
		padding: 30px 0;
		//background-position: 50px;
		&__content {
			width: 100%;
			
			&__title {
				font-size: 32px;
				margin-bottom: 16px;
			}
			
			&__detail {
				font-size: 16px;
				line-height: 28px;
			}
			
			.info {
				//flex-wrap: wrap;
				margin-top: 20px;
				
				&__list {
					width: 50%;
					
					&:first-child {
						margin-bottom: 20px;
					}
				}
			}
		}
	}
}

@media only screen and (max-width: 768px) {
	.dev-team {
		padding: 30px 0;
		
		&__content {
			width: 100%;
			
			&__title {
				font-size: 24px;
			}
			
			.info {
				//flex-wrap: wrap;
				margin-top: 16px;
				
				&__card {
					
					&__icon {
						width: 36px;
						height: 36px;
					}
					
					&__value {
						font-size: 18px;
					}
					
					&__label {
						font-size: 14px;
					}
				}
				
				&__list {
				
				}
			}
		}
	}
}

@media only screen and (max-width: 414px) {
	.dev-team {
		&__content {
			
			.info {
				flex-wrap: wrap;
			}
		}
	}
}
</style>